import { create } from 'zustand';
import type { AudioState, Mode, NoiseSuppressionStrength } from '../types';
import { clampMasterGainDb, MAX_MASTER_GAIN_DB } from '../audio/safety';

interface AppStore {
  audioState: AudioState;
  errorMessage: string | null;
  mode: Mode;
  masterGainDb: number;
  noiseSuppression: NoiseSuppressionStrength;
  tableModeActive: boolean;
  outputDeviceLabel: string | null;
  meterDb: number | null;

  setAudioState: (s: AudioState) => void;
  setError: (msg: string | null) => void;
  setMode: (m: Mode) => void;
  setMasterGainDb: (db: number) => void;
  setNoiseSuppression: (n: NoiseSuppressionStrength) => void;
  setTableModeActive: (b: boolean) => void;
  setOutputDeviceLabel: (l: string | null) => void;
  setMeterDb: (db: number | null) => void;
}

export const MAX_GAIN_DB = MAX_MASTER_GAIN_DB;

export const useAppStore = create<AppStore>((set) => ({
  audioState: 'idle',
  errorMessage: null,
  mode: 'conversation',
  masterGainDb: 6,
  noiseSuppression: 'normal',
  tableModeActive: false,
  outputDeviceLabel: null,
  meterDb: null,

  setAudioState: (s) => set({ audioState: s }),
  setError: (msg) => set({ errorMessage: msg }),
  setMode: (m) => set({ mode: m }),
  setMasterGainDb: (db) => set({ masterGainDb: clampMasterGainDb(db) }),
  setNoiseSuppression: (n) => set({ noiseSuppression: n }),
  setTableModeActive: (b) => set({ tableModeActive: b }),
  setOutputDeviceLabel: (l) => set({ outputDeviceLabel: l }),
  setMeterDb: (db) => set({ meterDb: db }),
}));
